import baseURL from "../../api/api"

export function getNotifications({ axiosPrivate, token }) {
    return axiosPrivate(`${baseURL}/notify`, {
        method: "GET",
        headers: { authorization: `Bearer ${token}` },
    })
}

export function updateNotification({
    axiosPrivate,
    token,
    notification_object_id,
    read_status,
}) {
    return axiosPrivate(`${baseURL}/notify`, {
        method: "PATCH",
        headers: { authorization: `Bearer ${token}` },
        data: { notification_object_id, read_status },
    })
}

export function deleteNotification({
    axiosPrivate,
    token,
    notification_object_id,
}) {
    return axiosPrivate(`${baseURL}/notify`, {
        method: "DELETE",
        headers: { authorization: `Bearer ${token}` },
        data: { notification_object_id },
    })
}
